@if (showLabel && label) {
    <div class="label-container">
        <span class="input-label" [class.required]="required">{{ doTranslate ? (label | translate) : label }}</span>
        @if (tooltip) {
            <app-tooltip [options]="tooltip" [doTranslate]="doTranslate"></app-tooltip>
        }
    </div>
}

<div class="chips" [attr.data-testid]="'ToggleChipList'">
    @for (chip of dataSource; track chip.id) {
        <button
            type="button"
            class="chip"
            [ngClass]="chip.type"
            [class.hidden]="chip.hidden"
            [class.selected]="isSelected(chip.id)"
            [class.disabled]="isDisabled"
            [disabled]="isDisabled"
            [attr.aria-pressed]="isSelected(chip.id)"
            (click)="toggle(chip)"
            [attr.data-testid]="'ToggleChipList-Chip-' + chip.id"
        >
            <span class="chip-label">{{ translateItems ? (chip.name | translate) : chip.name }}</span>
            @if (isSelected(chip.id)) {
                <i class="fas fa-check chip-check"></i>
            }
        </button>
    }
</div>
